import { useState, useEffect } from 'react'

interface BannerProps {
  imageUrl?: string | null
  imageUrlMobile?: string | null
  imageWidth?: string | number
  linkUrl?: string
  openInNewTab?: boolean
  onClick?: () => void
  mobileBreakpoint?: number
}

export default function Banner({
  imageUrl = null,
  imageUrlMobile = null,
  imageWidth = 'auto',
  linkUrl = '',
  openInNewTab = true,
  onClick,
  mobileBreakpoint = 768
}: BannerProps) {
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < mobileBreakpoint)
    }

    checkIfMobile()

    window.addEventListener('resize', checkIfMobile)

    return () => {
      window.removeEventListener('resize', checkIfMobile)
    }
  }, [mobileBreakpoint])

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick()
    }
  }
  const currentImageUrl = isMobile && imageUrlMobile ? imageUrlMobile : imageUrl

  const bannerHeight = isMobile ? 'h-24' : 'h-32'

  const bannerContent = (
    <div className={`w-full ${bannerHeight} relative cursor-pointer overflow-hidden`}>
      <div className="flex h-full w-full justify-center">
        <div className="absolute inset-0 flex items-center justify-center">
          <img
            src={currentImageUrl ?? ''}
            alt="Banner image"
            className="mx-auto h-full w-full object-contain md:object-contain"
            style={{
              maxWidth: '90%',
              width: imageWidth
            }}
          />
        </div>
      </div>
    </div>
  )

  if (linkUrl) {
    return (
      <a
        href={linkUrl}
        target={openInNewTab ? '_blank' : '_self'}
        rel={openInNewTab ? 'noopener noreferrer' : ''}
        onClick={handleClick}
        className="block w-full">
        {bannerContent}
      </a>
    )
  }

  return <div onClick={handleClick}>{bannerContent}</div>
}
